import { render, staticRenderFns } from "./ListTraining.vue?vue&type=template&id=2bd1c984"
import script from "./ListTraining.vue?vue&type=script&lang=js"
export * from "./ListTraining.vue?vue&type=script&lang=js"
import style0 from "./ListTraining.vue?vue&type=style&index=0&id=2bd1c984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports